<script setup lang="ts">
import { faExclamationTriangle } from "@fortawesome/pro-regular-svg-icons";
import ModalBase from "@/components/modal/modal-container.vue";
import ModalTitle from "@/components/modal/modal-title.vue";
import ModalContent from "@/components/modal/modal-content.vue";
import ModalFooterConfirmation from "@/components/modal/modal-footer-confirmation.vue";
import useNotifications from "@/composables/notifications";
import { computed } from "vue";
import { useSendCreditNote } from "@/composables/billing/credit-notes";

const props = defineProps<{
  docId: number
  projectCode: number
  projectName: string
}>()
const emit = defineEmits<{ close: [] }>()

const { mutateAsync, isPending } = useSendCreditNote()
const { addError, addSuccess } = useNotifications()
const creditNoteDisplayName = computed(
  () => `${props.projectName} (${props.projectCode})`
)

async function sendCreditNote() {
  try {
    await mutateAsync(props.docId)

    addSuccess({
      title: 'Credit Note Sent Successfully',
      allowHtml: true,
      message: `Credit Note <b>${props.docId}</b> for <b>${creditNoteDisplayName.value}</b> has been successfully sent.`
    })

    emit('close')
  } catch (e: unknown) {
    addError({
      title: 'Credit Note Not Sent',
      allowHtml: true,
      message: `Credit Note <b>${props.docId}</b> for <b>${creditNoteDisplayName.value}</b> could not be sent due to an error that occurred. Please try again.`
    })
  }
}
</script>

<template>
  <ModalBase @close="$emit('close')">
    <ModalTitle>
      Send Email Confirmation
    </ModalTitle>
    <ModalContent :icon="faExclamationTriangle" icon-variant="warning">
      <p>
        Are you sure you would like to send Credit Note <b>{{ props.docId }}</b> for <b>{{ creditNoteDisplayName }}</b>?
      </p>
    </ModalContent>
    <ModalFooterConfirmation
      @reject="$emit('close')"
      @confirm="sendCreditNote()"
      :pending="isPending"
    />
  </ModalBase>
</template>

<style scoped lang="scss">

</style>
